
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/personal-plan/[[...slug]]",
      function () {
        return require("private-next-pages/personal-plan/[[...slug]].page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/personal-plan/[[...slug]]"])
      });
    }
  